import { TAGS } from "@/store/api"
import {
  BATTLE_END_REASON,
  BATTLE_OUTCOME,
  BATTLE_STATE,
  type IBattleView
} from "@/store/apis/battleAPI/battle.types"

export type IBattleEndPlan =
  | {
      kind: "reward"
      killId: string
    }
  | {
      kind: "result"
      outcome: BATTLE_OUTCOME.LOSS | BATTLE_OUTCOME.FLEE
      endReason: BATTLE_END_REASON | null
    }

export const planBattleEnd = (view: IBattleView): IBattleEndPlan | null => {
  if (view.state === BATTLE_STATE.OPEN) {
    return null
  }

  if (view.outcome === BATTLE_OUTCOME.WIN && view.killId) {
    return {
      kind: "reward",
      killId: view.killId
    }
  }

  if (
    view.outcome === BATTLE_OUTCOME.LOSS ||
    view.outcome === BATTLE_OUTCOME.FLEE
  ) {
    return {
      kind: "result",
      outcome: view.outcome,
      endReason: view.endReason
    }
  }

  return null
}

export interface IBattleEndRegistryEvents {
  claim(battleId: string): boolean
  isEnded(battleId: string): boolean
}

export const createBattleEndRegistry = (): IBattleEndRegistryEvents => {
  const ended = new Set<string>()

  return {
    claim(battleId: string): boolean {
      if (ended.has(battleId)) {
        return false
      }
      ended.add(battleId)
      return true
    },
    isEnded(battleId: string): boolean {
      return ended.has(battleId)
    }
  }
}

export const battleEnds = createBattleEndRegistry()

export const battleEndInvalidates = (
  plan: IBattleEndPlan
): (TAGS.HERO | TAGS.INVENTORY | TAGS.WALLET)[] => {
  if (plan.kind === "reward") {
    return [TAGS.HERO, TAGS.INVENTORY, TAGS.WALLET]
  }
  return [TAGS.HERO]
}
